import { render, staticRenderFns } from "./MenuPermissionList2.vue?vue&type=template&id=487c3a04"
import script from "./MenuPermissionList2.vue?vue&type=script&lang=js"
export * from "./MenuPermissionList2.vue?vue&type=script&lang=js"
import style0 from "./MenuPermissionList2.vue?vue&type=style&index=0&id=487c3a04&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports